import * as Sentry from "@sentry/vue";

const SENTRY_DSN = 'https://5be3f099807a1d280d8ba439386c98ab@o4503936362872832.ingest.us.sentry.io/4511948768149504';

// environnement de l'app enregistré dans ton .env
window.env = import.meta.env.VITE_ENV
export let useSentry = (app : any, router : any) => {
    if (window.env != 'local') {
        Sentry.init({
            app,
            dsn: SENTRY_DSN,
            integrations: [
            Sentry.browserTracingIntegration({ router }),
            // vidéos replay
            Sentry.replayIntegration()
            ],  
            // si env local, preprod, prod...
            environment: window.env,
            // nom de la realse pour track quel version de l'app à générer l'erreur
            release: "1.0",
            // % de track des erreurs
            tracesSampleRate: 1.0, 
            // url autorisées au tracking
            tracePropagationTargets: ["localhost", /^https:\/\/api\.hp\.prep\.digiworks\.fr/, /^https:\/\/borne\.hp\.prep\.digiworks\.fr/, /^https:\/\/api\.hippodrome-manager\.com/, /^https:\/\/borne-pari\.hippodrome-manager\.com/],
            // % de capture vidéo sans erreur (juste comment l'user intéragit avec l'app)
            replaysSessionSampleRate: 0,
            // % de capture vidéo lors des erreurs
            replaysOnErrorSampleRate: 0.25,
        });
    }
}